import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep2_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F24.css';
import backIcon2 from '../../../Assests/backIcon2.svg'
function Frame24() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
   

        return (
            <div className="F24_imageAnimate" >
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F24_entryBox">
                    <div className="F24_heading">
                        {language === 'english' ?
                            <p className="F24_headingEnglish">Help Saira
                                <p className="F24_episodeNoEnglish">Episode 2</p>
                            </p>
                            :
                            <p className="F24_headingUrdu"> سائرا کو مدد چاہیے
                                <p className="F24_episodeNoUrdu">قسط دوئم</p>
                            </p>
                        }
                    </div>

                    <div className="F24_timeline">
                        <div className='F24_timelineBar'>
                            <div className='F24_timelineFill'></div>
                            <span className='F24_timelineText'>
                                1/19
                            </span>
                        </div>
                    </div>

                    <div className="F24_nextFrames">
                        <div className="F24_nextFrame1"></div>
                        <div className="F24_nextFrame2"></div>
                        <div className="F24_nextFrame3"></div>
                    </div>

                    <div className='F24_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep2_lastVisitFrame(1)) }} className='F24_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
}

export default Frame24;